









































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { GetCurrentUserData, PostUserData } from "@/request/account";
import Copy from "@/components/copy.vue";
import Header from "../../components/common-header.vue";
import LeftNav from "../../components/left-nav.vue";
import { User } from "@/types/user";
@Component({
  components: {
    Header,
    LeftNav,
    Copy,
  },
})
export default class AccountManage extends Vue {
  private ifCompose: boolean = false;
  private user: User = {};
  private tempUser: User = {};
  /**
   * @description 获取用户信息
   */
  private fetchUserData(): void {
    GetCurrentUserData(this).then((data: any) => {
      this.user = data;
    });
  }
  /**
   * @description 开始编辑
   */
  private startCompose(): void {
    this.tempUser = _.cloneDeep(this.user);
    this.ifCompose = true;
  }
  /**
   * @description 取消
   */
  private cancel(): void {
    this.ifCompose = false;
    this.tempUser = {};
  }
  /**
   * @description 保存
   */
  private save(): void {
    const params: any = _.cloneDeep(this.tempUser);
    PostUserData(this, params).then((data: any) => {
      this.$message.success("修改成功");
      this.tempUser = {};
      this.ifCompose = false;
      this.fetchUserData();
    });
  }
  /**
   * @description 初始化
   */
  private mounted(): void {
    this.fetchUserData();
  }
}
